import { render, staticRenderFns } from "./CollectionList.vue?vue&type=template&id=46915753&scoped=true&"
import script from "./CollectionList.vue?vue&type=script&lang=ts&"
export * from "./CollectionList.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionList.vue?vue&type=style&index=0&id=46915753&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46915753",
  null
  
)

export default component.exports